import React, { useState, useContext, useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import { register } from '../api/'
import { LocaleContext } from '../routes'
import Register, { Header, Footer } from '../styles/register'
import { Title, Content, TermsLink, WrapperBottomButton } from '../styles/elements'
import BirthDate from '../views/BirthDate'
import FullPageAlert from '../views/FullPageAlert'
import Gender from '../views/Gender'
import Button from '../views/common/Button'
import HeaderImage from '../planets/intro.jpg'
import Notification from '../views/common/Notification'
import BaseHeader from '../views/common/Header'

export default ({ loyalty }) => {
  const timeError = 7500
  const [loading, setLoading] = useState()
  const [isError, setError] = useState()
  const [isRegistered, setRegistered] = useState()
  const [birthdate, setBirthdate] = useState()
  const [gender, setGender] = useState()

  const onGenderChange = genderValue => setGender(genderValue)
  const onCalendarChange = calendarValue => setBirthdate(calendarValue)
  const showErrorNotification = () => setError(true)

  useEffect(() => {
    isError && setTimeout(() => setError(false), timeError + 1000)
  })

  const registerInLoyalty = async (isMale, birthDate) => {
    setLoading(true)
    const registerResponse = await register(isMale, birthDate)
    setLoading(false)
    registerResponse && setRegistered(registerResponse)
    !registerResponse && showErrorNotification()
  }

  const locale = useContext(LocaleContext)

  const goHome = () => window.parent.postMessage('onLoyaltyClosed', '*')

  return (
    !isRegistered && loyalty.payload ? (
      <>
        <FullPageAlert buttonText="ENTER_LOYALTY" headerImage={HeaderImage}>
          <Title>{loyalty.payload.title}</Title>
          <Content>{loyalty.payload.description}</Content>
        </FullPageAlert>
        {isError &&
          <Notification type="error" timeError={timeError} />
        }
        <BaseHeader onBack={goHome} />
        <Register>
          <Header>{locale.REGISTER_TITLE}.</Header>
          <Gender onChange={onGenderChange} />
          <BirthDate birthdate={birthdate} onChange={onCalendarChange} />
          <WrapperBottomButton>
            <Footer>
              {locale.REGISTER_LEGAL[1]}
              <TermsLink
                target="_blank"
                rel="noopener noreferrer nofollow"
                href={loyalty.payload && loyalty.payload.rulesLink}
              >
                {locale.REGISTER_LEGAL[2]}
              </TermsLink>
              {locale.REGISTER_LEGAL[3]}.
          </Footer>
            <Button
              text="register"
              onClick={() => registerInLoyalty(gender, birthdate)}
              loading={loading}
            />
          </WrapperBottomButton>
        </Register>
      </>
    )
      :
      <Redirect to="/" />
  )
}
